/**
 * Złata Přilba / Zlatá Stuha — bootstrap bez jQuery/Owl (krok 5.3).
 * Krok 6.3 — inteligentny polling (pauza / stop / interwały).
 * Widok meczu: karuzela matchlist.
 */

import { onReady } from '../modules/dom.js';
import { initSmoothAnchorScroll } from '../modules/smooth-scroll.js';
import { initNavToggler } from '../modules/nav-toggler.js';
import { initHeaderSearchToggle } from '../modules/header-search-toggle.js';
import { initMatchCarousel, shrinkLongMatchTitles } from '../modules/match-carousel.js';
import { getMatchSlugFromPath } from '../modules/match-slug.js';
import { pollFragment } from '../modules/polling.js';
import { scrollCourseToBottom, hideDuplicateHeats } from '../modules/course-ui.js';
import { initZlataScoring, refreshZlataFromCourse } from '../modules/scoring-zlata.js';
import {
    INTERVAL_LIVE_MS,
    INTERVAL_PLANNED_MS,
    isTerminalMatchStatus,
    readInitialMatchStatus,
} from '../modules/match-poll-status.js';

onReady(() => {
    initSmoothAnchorScroll();
    initNavToggler();
    initHeaderSearchToggle();
    scrollCourseToBottom(true);

    initMatchCarousel();
    shrinkLongMatchTitles();

    initZlataScoring();

    window.setTimeout(hideDuplicateHeats, 1000);

    const initialStatus = readInitialMatchStatus();
    const livePollOptions = {
        intervalLiveMs: INTERVAL_LIVE_MS,
        intervalPlannedMs: INTERVAL_PLANNED_MS,
        pauseWhenHidden: true,
        stopWhenTerminal: true,
    };

    if (!isTerminalMatchStatus(initialStatus)) {
        pollFragment('.match-course', () => 'course.php?match=' + getMatchSlugFromPath(), {
            ...livePollOptions,
            highlightCourse: true,
            onDone: () => {
                refreshZlataFromCourse();
                window.setTimeout(hideDuplicateHeats, 1000);
            },
        });

        pollFragment('.match-comments-ajax', () => 'comments.php?match=' + getMatchSlugFromPath(), {
            ...livePollOptions,
        });
    }

    const slug = getMatchSlugFromPath();
    pollFragment(
        '.match-carousel__container',
        () => (slug ? 'matchlist.php?match=' + encodeURIComponent(slug) : 'matchlist.php'),
        {
            intervalMs: INTERVAL_LIVE_MS,
            pauseWhenHidden: true,
            onDone: (container) => {
                if (!container) {
                    return;
                }
                initMatchCarousel(container);
                shrinkLongMatchTitles(container);
            },
        }
    );
});
